var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-btns"},_vm._l((_vm.list),function(item){return _c('el-button',{key:item,attrs:{"size":"mini","type":_vm.val === item ? 'primary' : ''},on:{"click":function($event){return _vm.handleClick(item)}}},[_vm._v("\n    "+_vm._s(item)+"\n  ")])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d89d280","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cuscom/btns-group.vue
// module id = null
// module chunks = 